export default {
  // Common
  save: "Salva",
  cancel: "Annulla",
  loading: "Caricamento...",
  inactive: "Inattivo",
  active: "Attivo",
  edit: "Modifica",
  delete: "Elimina",
  name: "Nome",
  email: "Email",
  description: "Descrizione",
  date: "Data",
  time: "Orario",
  status: "Stato",
  notes: "Note",
  close: "Chiudi",
  language: "Lingua",

  // Auth
  auth_welcome: "Bentornato",
  auth_create: "Crea account",
  auth_signin_sub: "Accedi alla tua dashboard",
  auth_create_sub: "Configura il tuo sistema di prenotazione",
  auth_business_name: "Nome dell'azienda",
  auth_business_placeholder: "Il nome della tua azienda",
  auth_email_placeholder: "admin@azienda.com",
  auth_password: "Password",
  auth_password_placeholder: "Inserisci la password",
  auth_signing_in: "Caricamento...",
  auth_toggle_login: "Hai già un account? Accedi",
  auth_toggle_register: "Non hai un account? Registrati",
  auth_success_register: "Account creato",
  auth_success_login: "Bentornato!",
  auth_error: "Autenticazione fallita",
  auth_email_invalid: "Inserisci un indirizzo email valido",
  auth_forgot_password: "Password dimenticata?",
  auth_password_confirm: "Conferma password",
  auth_password_confirm_placeholder: "Reinserisci la password",
  auth_password_mismatch: "Le password non corrispondono",

  forgot_title: "Password dimenticata",
  forgot_sub: "Inserisci il tuo indirizzo email e ti invieremo un codice di reset.",
  forgot_send: "Invia codice",
  forgot_sent_title: "Controlla la tua email",
  forgot_sent_sub: "Abbiamo inviato un codice a 6 cifre al tuo indirizzo email. Scade in 30 minuti.",
  forgot_enter_code: "Inserisci il codice",
  forgot_back_login: "Torna al login",

  reset_title: "Reimposta password",
  reset_sub: "Inserisci il codice a 6 cifre dalla tua email e scegli una nuova password.",
  reset_code_label: "Codice di reset",
  reset_new_password: "Nuova password",
  reset_password_placeholder: "Min. 4 caratteri",
  reset_password_hint: "Minimo 4 caratteri",
  reset_password_min: "La password deve contenere almeno 4 caratteri",
  reset_invalid_code: "Codice non valido o scaduto",
  reset_submit: "Reimposta password",
  reset_done_title: "Password aggiornata!",
  reset_done_sub: "La tua password è stata modificata. Ora puoi accedere.",

  // Sidebar
  nav_dashboard: "Dashboard",
  nav_services: "Servizi",
  nav_staff: "Personale",
  nav_appointments: "Appuntamenti",
  nav_calendar: "Calendario",
  nav_settings: "Impostazioni",
  nav_widget: "Widget",
  nav_logout: "Esci",

  // Dashboard
  dashboard_title: "Dashboard",
  dashboard_loading: "Caricamento dashboard...",
  dashboard_today: "Oggi",
  dashboard_total: "Prenotazioni totali",
  dashboard_pending: "In attesa",
  dashboard_services: "Servizi",
  dashboard_todays_schedule: "Programma di oggi",
  dashboard_upcoming: "In arrivo",
  dashboard_view_all: "Vedi tutti",
  dashboard_no_today: "Nessun appuntamento oggi",
  dashboard_no_upcoming: "Nessun appuntamento in arrivo",

  // Services
  services_title: "Servizi",
  services_add: "Aggiungi servizio",
  services_empty: "Nessun servizio ancora",
  services_empty_sub: "Crea il tuo primo servizio per iniziare a ricevere prenotazioni",
  services_new: "Nuovo servizio",
  services_edit: "Modifica servizio",
  services_new_sub: "Crea un nuovo servizio prenotabile",
  services_edit_sub: "Aggiorna i dettagli del servizio",
  services_name_placeholder: "es. Taglio capelli",
  services_desc_placeholder: "Breve descrizione",
  services_duration: "Durata",
  services_price: "Prezzo",
  services_buffer: "Tempo buffer",
  services_color: "Colore",
  services_name_required: "Il nome del servizio è obbligatorio",
  services_created: "Servizio creato",
  services_updated: "Servizio aggiornato",
  services_deleted: "Servizio eliminato",
  services_load_error: "Errore nel caricamento dei servizi",
  services_save_error: "Errore nel salvataggio",
  services_delete_error: "Errore nell'eliminazione",
  services_delete_confirm_title: "Elimina servizio",
  services_delete_confirm_sub: "Sei sicuro di voler eliminare {{name}}? Questa azione non può essere annullata.",
  services_translations: "Traduzioni",
  services_trans_name_placeholder: "Nome del servizio in questa lingua",
  services_trans_desc_placeholder: "Descrizione in questa lingua (opzionale)",

  // Staff
  staff_title: "Personale",
  staff_add: "Aggiungi personale",
  staff_empty: "Nessun membro del personale ancora",
  staff_empty_sub: "Aggiungi personale affinché i clienti possano scegliere con chi prenotare",
  staff_new: "Aggiungi personale",
  staff_edit: "Modifica personale",
  staff_new_sub: "Aggiungi un nuovo membro del team",
  staff_edit_sub: "Aggiorna i dettagli del personale",
  staff_email_optional: "Email (opzionale)",
  staff_email_placeholder: "mario@esempio.com",
  staff_name_placeholder: "es. Mario Rossi",
  staff_name_required: "Il nome è obbligatorio",
  staff_created: "Personale aggiunto",
  staff_updated: "Personale aggiornato",
  staff_deleted: "Personale rimosso",
  staff_load_error: "Errore nel caricamento del personale",
  staff_save_error: "Errore nel salvataggio",
  staff_delete_error: "Errore nell'eliminazione",
  staff_delete_confirm_title: "Elimina membro del personale",
  staff_delete_confirm_sub: "Sei sicuro di voler eliminare {{name}}? Questa azione non può essere annullata.",

  // Appointments
  appointments_title: "Appuntamenti",
  appointments_search: "Cerca per nome, email o servizio...",
  appointments_filter_all: "Tutti",
  appointments_filter_confirmed: "Confermati",
  appointments_filter_pending: "In attesa",
  appointments_filter_cancelled: "Annullati",
  appointments_none: "Nessun appuntamento trovato",
  appointments_customer: "Cliente",
  appointments_service: "Servizio",
  appointments_staff: "Personale",
  appointments_edit: "Modifica",
  appointments_confirm: "Conferma",
  appointments_cancel: "Annulla",
  appointments_delete: "Elimina",
  appointments_edit_title: "Modifica appuntamento",
  appointments_edit_sub: "Aggiorna i dettagli dell'appuntamento",
  appointments_notes_placeholder: "Aggiungi note...",
  appointments_status_updated: "Stato aggiornato: {{status}}",
  appointments_load_error: "Errore nel caricamento",
  appointments_status_error: "Errore nell'aggiornamento dello stato",
  appointments_update_error: "Errore nell'aggiornamento",
  appointments_delete_error: "Errore nell'eliminazione",
  appointments_updated: "Appuntamento aggiornato",
  appointments_deleted: "Appuntamento eliminato",

  // Calendar
  calendar_title: "Calendario",
  calendar_today: "Oggi",
  calendar_reschedule_ok: "Riprogrammato",
  calendar_reschedule_err: "Errore nella riprogrammazione",
  calendar_load_error: "Errore nel caricamento degli appuntamenti",

  // Settings
  settings_title: "Impostazioni",
  settings_save: "Salva modifiche",
  settings_saving: "Salvataggio...",
  settings_business_info: "Informazioni aziendali",
  settings_business_name: "Nome azienda",
  settings_business_desc: "Descrizione",
  settings_business_desc_placeholder: "Breve descrizione della tua attività",
  settings_booking_url: "URL prenotazione",
  settings_working_hours: "Orari di lavoro",
  settings_hours_to: "a",
  settings_widget_appearance: "Aspetto del widget",
  settings_primary_color: "Colore primario",
  settings_accent_color: "Colore accento",
  settings_saved: "Impostazioni salvate",
  settings_save_error: "Errore nel salvataggio",
  settings_load_error: "Errore nel caricamento delle impostazioni",
  settings_link_copied: "Link di prenotazione copiato!",
  settings_approval_title: "Approvazione prenotazioni",
  settings_approval_sub: "Conferma automaticamente le prenotazioni in sospeso se non vengono revisionate entro il tempo selezionato.",
  settings_approval_off: "Disattivato — solo approvazione manuale",
  settings_approval_30m: "Dopo 30 minuti",
  settings_approval_1h: "Dopo 1 ora",
  settings_approval_2h: "Dopo 2 ore",
  settings_approval_6h: "Dopo 6 ore",
  settings_approval_12h: "Dopo 12 ore",
  settings_approval_active: "Le prenotazioni vengono confermate automaticamente dopo {{hours}}h",
  settings_approval_inactive: "L'approvazione automatica è disattivata",

  // Widget Preview
  widget_preview_title: "Widget di prenotazione",
  widget_preview_open: "Apri widget",
  widget_preview_loading: "Caricamento link di prenotazione...",
  widget_preview_embed: "Codice di incorporamento",
  widget_preview_live: "Anteprima live",
  widget_preview_embed_hint: "Copia e incolla questo codice nel tuo sito per incorporare il widget.",
  widget_preview_copied: "Copiato negli appunti",

  // Booking Widget
  booking_book_appointment: "Prenota appuntamento",
  booking_not_found: "Azienda non trovata.",
  booking_not_found_sub: "Controlla il link di prenotazione e riprova.",
  booking_step_service: "Servizio",
  booking_step_staff: "Personale",
  booking_step_datetime: "Data e orario",
  booking_step_details: "Dettagli",
  booking_choose_service: "Scegli un servizio",
  booking_no_services: "Nessun servizio disponibile",
  booking_choose_staff: "Scegli un membro del personale",
  booking_any_staff: "Qualsiasi disponibile",
  booking_any_staff_sub: "Assegneremo il primo membro disponibile",
  booking_pick_datetime: "Scegli data e orario",
  booking_available_times: "Orari disponibili per {{date}}",
  booking_no_slots: "Nessuno slot disponibile per questa data",
  booking_continue: "Continua",
  booking_your_details: "I tuoi dati",
  booking_name: "Nome *",
  booking_email: "Email *",
  booking_phone: "Telefono",
  booking_name_placeholder: "Il tuo nome completo",
  booking_email_placeholder: "tua@email.com",
  booking_phone_placeholder: "Numero di telefono",
  booking_confirm: "Conferma prenotazione",
  booking_confirming: "Prenotazione...",
  booking_pending_title: "Richiesta ricevuta!",
  booking_pending_sub: "Ti invieremo un'email non appena il tuo appuntamento sarà confermato.",
  booking_success_title: "Prenotazione confermata!",
  booking_success_sub: "Il tuo appuntamento è stato programmato",
  booking_service_label: "Servizio",
  booking_date_label: "Data",
  booking_time_label: "Orario",
  booking_another: "Prenota un altro appuntamento",
  booking_failed: "Prenotazione fallita. Riprova.",
  booking_gdpr_text: "Accetto che i miei dati personali (nome, e-mail, numero di telefono) vengano trattati esclusivamente per la gestione di questa prenotazione, nel rispetto delle normative vigenti sulla protezione dei dati (LPD/GDPR). I miei dati non saranno condivisi con terzi.",
  booking_select_hint: "Seleziona uno o più servizi",
  booking_available: "Disponibile",
  booking_unavailable: "Non disponibile",
  booking_email_invalid: "Inserisci un indirizzo email valido",
};
